module.exports = __webpack_public_path__ + "media/images/tailwind/form-down-arrow-e6d99d6fff68101f2e895db6bce0408f.png";